import React, { Ref } from 'react'

import Select, { SelectProps } from 'components/ui/Select/Select'

const PartnerTypeSelect = React.forwardRef(
  (props: SelectProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const options = [
      { value: 'Agent', text: 'Agent' },
      { value: 'LenderPartner', text: 'Lender' },
      { value: 'PropertyManager', text: 'Property Manager' }
    ]

    return (
      <div className="relative rounded-md shadow-sm w-full">
        <Select options={options} {...props} ref={ref} />
      </div>
    )
  }
)

export default PartnerTypeSelect
